import { useQuery } from 'hooks/useCustomQuery';
import getSRTServiceProfile from 'API/SRT/getSRTServiceProfile';

/**
 * The saved SRT service profile, loaded when editing an existing one.
 *
 * @param {object}   params
 * @param {string}   params.scope     `Partner/{partnerID}` or `Wholesaler/{wholesalerID}`.
 * @param {string}   params.mode      Form mode; only `EDIT` fetches.
 * @param {function} [params.onSuccess] Receives the raw response.
 */
const useGetSRTServiceProfile = ({ scope, mode, onSuccess }) => {
    return useQuery({
        queryKey: ['srtSPData', scope, mode],
        queryFn: () => getSRTServiceProfile({ scope }),
        enabled: mode === 'EDIT' && Boolean(scope),
        // FIX:(3168): drop the cache on unmount so every edit refetches the
        // saved profile instead of reopening on stale data.
        cacheTime: 0,
        onSuccess,
    });
};

export default useGetSRTServiceProfile;
